/* src/components/library-item-filters-selected/library-item-filters-selected.component.scss */
:host {
  display: block;
}
.within-pdf {
  display: inline-block;
}
/*# sourceMappingURL=library-item-filters-selected.component-SAZJ6GR6.css.map */
